import React, { useEffect, useState, useCallback, useRef } from "react";
import Footer from "../components/footer";
import Header from "../components/header";
import SideNav from "../components/sidenav";

import axios from "axios";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import Loader from "../components/loader";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';
import { FaCalendarAlt } from 'react-icons/fa';
import ReactCountryFlag from "react-country-flag";

import CustomEditor from "../../../component/CustomEditor"; // Import the centralized CKEditor component

const AddInventory = () => {

    let userInfo = JSON.parse(localStorage.getItem('admin-info'));
    const { id } = useParams();
    const navigate = useNavigate();
    const editorRef = useRef();
    const [loading, setLoading] = useState(true);

    const [artworks, setArtwork] = useState([]);
    const [statusType, setStatusType] = useState([]);
    const [GSTType, setGSTType] = useState([]);
    const [ShipGSTType, setShipGSTType] = useState([]);
    const [ShipWeight, setShipWeight] = useState([]);

    const [newdata, setNewdata] = useState({
        selectedArtwork: '0', quantity: '1', selectedStatus: '0',
        entryDate: new Date(), endDate: new Date(), mrp: '', discount: 0,
        selectedGST: '12', selectedShippingWeight: '0', selectedShippingGST: '18', conditions: '',
        artworkTitle: '', category:'', categoryType:'', artistname:'', price:'', size:'', weight:'', image:'', commission:'',
        shippingWeight: '', // Selected weight ID
        shippingCostINR: 0, // Shipping cost in INR
        shippingCostOther: 0, // Shipping cost in Other currency
    });

    // Implementation of conversion value in datatable

    // State for currency conversion
    const [currencyRates, setCurrencyRates] = useState([]);
    const [showDataTable, setShowDataTable] = useState(false);

    // Function to fetch currency conversion rates
    const fetchCurrencyRates = async (updatedData) => {
        try {
           
            // Destructure relevant fields from updatedData
            const { mrp, discount, selectedGST, selectedShippingWeight, selectedShippingGST } = updatedData;
            const price = parseFloat(mrp) || 0;
            const discountRate = parseFloat(discount) || 0;

            // Calculate discount value, discounted price, GST, and final price
            const discountValue = discountRate > 0 ? price * (discountRate / 100) : 0;
            const discountedPrice = price - discountValue;
            const gstValue = (discountedPrice * selectedGST) / 100;
            const finalPrice = discountedPrice + gstValue;

            // Fetch currency details
            const response = await fetch('https://igapi.heuristticminds.com/api/CurrencyList/Get-GetCurrencyDetailsForBuyer');
            const data = await response.json();

            // Fetch shipping costs based on the selected weight
            let shipCostINR = 0;
            let shipCostOthers = 0;
            if (selectedShippingWeight && selectedShippingWeight !== '0') {
                const shippingCostResponse = await fetch(`https://igapi.heuristticminds.com/api/InventoryList/Get-GetShippingCostByID?id=${selectedShippingWeight}`);
                const shippingData = await shippingCostResponse.json();

                shipCostINR = shippingData?.shippingCostINR || 0;
                shipCostOthers = shippingData?.shippingCostOthers || 0;
                
            }

            const shipgstValueINR = (shipCostINR * selectedShippingGST) / 100;
            const shipgstValueOthers = (shipCostOthers * selectedShippingGST) / 100;
            // Map through the currency data and calculate rates
            const rates = data.map((currency) => {
                const conversionRate = parseFloat(currency.value) || 1;
                const isINR = currency.id === 4;

                return {
                    code: currency.code,
                    currency: currency.currency,
                    mrp: isINR ? price : price / conversionRate,
                    discount: isINR ? discountValue : discountValue / conversionRate,
                    gst: isINR ? gstValue : gstValue / conversionRate,
                    salePrice: isINR ? discountedPrice : discountedPrice / conversionRate,
                    convertedValue: isINR ? finalPrice : finalPrice / conversionRate,
                    shippingCost: isINR ? shipCostINR : shipCostOthers / conversionRate,
                    shippingGST: isINR ? shipgstValueINR : shipgstValueOthers / conversionRate,
                    value: conversionRate,
                };
            });
            
            // Update state with the calculated rates
            setCurrencyRates(rates);
        } catch (error) {
            console.error('Error fetching currency rates:', error);
        }
    };

    // useEffect to call fetchCurrencyRates when newdata changes
    useEffect(() => {
        if (newdata) {
            fetchCurrencyRates(newdata);
        }
    }, [newdata]);


    const { mrp = '', discount = 0 } = newdata;

    const isMrpZero = parseFloat(mrp) === 0;
    const isDiscountZero = parseFloat(discount) === 0; // will be false if discount is 0
    const isMrpBlank = mrp === '';
    const isDiscountBlank = discount === 0; // check against the number

    // Determine if the DataTable should be displayed
    const shouldDisplayDataTable = !(isMrpZero && isDiscountZero) && !(isMrpBlank && isDiscountBlank);


    // End of Conversion

    const fetchData = async (url, setData) => {
        try {
            const response = await fetch(url);
            const data = await response.json();
            setData(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        const fetchDropdowns = async () => {
            fetchData('https://igapi.heuristticminds.com/api/InventoryList/Bind-BindNewInventoryList', setArtwork);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-StatusList', setStatusType);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindGSTSlotList', setGSTType);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindShippingGSTSlotList', setShipGSTType);
            fetchData('https://igapi.heuristticminds.com/api/BindDropDownList/Bind-BindShippingWeightSlotList', setShipWeight);

            if (id) {
                await fetchInventoryDetails();
            }
        };
        fetchDropdowns();
    }, [id]);

    const fetchInventoryDetails = useCallback(async () => {
        if (id) {
            try {
                const response = await axios.get(`https://igapi.heuristticminds.com/api/InventoryList/Get-GetInventoryDetailsToEditByID?id=${id}`);
                const data = response.data;    
                
                const response2 = await axios.get(`https://igapi.heuristticminds.com/api/InventoryList/Get-GetArtworkDetailsForInventoryByID?id=${id}&&mode=1`);
                const data2 = response2.data;
                setNewdata(prevData => ({
                    ...prevData,
                    artworkTitle: data.productTitle,
                    quantity: data.quantity,
                    selectedStatus: data.status,
                    entryDate: new Date(data.entryDate),
                    endDate: new Date(data.expiryDate),
                    mrp: data.mrp,
                    discount: data.discount,
                    selectedGST: data.gst,
                    selectedShippingWeight: data.shippingWeight,
                    selectedShippingGST: data.shippingGST,
                    conditions: data.conditions,
                    image: data2.image,
                    price:data2.price,
                    artistname: data2.artistName,
                    category: data2.category,
                    categoryType: data2.categoryType,
                    size: data2.size,
                    weight: data2.weight,
                    commission: data2.commission
                }));
                

            } catch (error) {
                console.error('Error fetching Inventory details:', error);
            }
        }
    }, [id]);

    useEffect(() => {
        fetchInventoryDetails();
    }, [fetchInventoryDetails]);

    const handleDateChange = (date, name) => {
        setNewdata({ ...newdata, [name]: date });
    };

    useEffect(() => {
        if (!id) { // Assuming 'id' is used to check if it's add mode
            setNewdata(prev => ({
                ...prev,
                endDate: new Date('2099-12-31') // Ensure default date is set
            }));
        }
    }, [id]);

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <div className="input-group">
            <input
                type="text"
                className="form-control"
                value={value}
                onClick={onClick}
                readOnly
                ref={ref}
            />
            <div className="input-group-append">
                <span className="input-group-text" onClick={onClick}>
                    <FaCalendarAlt />
                </span>
            </div>
        </div>
    ));

    const handleEditorChange = (content) => {
        setNewdata(prevData => ({
            ...prevData,
            conditions: content
          }));
    };

    const handleAddInventoryClick = async () => {
        if (!id && newdata.selectedArtwork === '0') {
            alert('Please Select Artwork');
            return;
        }
        if (isNaN(newdata.quantity) || newdata.quantity < 1) {
            alert('Please Enter Quantity, minimum 1 quantity is required');
            return;
        }
        if (newdata.selectedStatus === '0') {
            alert('Please Select Status');
            return;
        }
        if (newdata.mrp === '') {
            alert('Please Enter Price.');
            return;
        }
        if (newdata.selectedGST === '0') {
            alert('Please Select GST Slot.');
            return;
        }
        if (newdata.selectedShippingWeight === '0') {
            alert('Please Select Shipping Weight.');
            return;
        }
        if (newdata.selectedShippingGST === '0') {
            alert('Please Select Shipping GST.');
            return;
        }

        const formattedEntryDate = format(newdata.entryDate, 'yyyy-MM-dd');
        const formattedEndDate = format(newdata.endDate, 'yyyy-MM-dd');

        let postData = {
            "product_id": parseInt(newdata.selectedArtwork, 10),
            "quantity": parseInt(newdata.quantity, 10),
            "mrp": parseFloat(newdata.mrp).toFixed(2),
            "discount": parseFloat(newdata.discount).toFixed(2),
            "status": parseInt(newdata.selectedStatus, 10),
            "entryDate": formattedEntryDate,
            "endDate": formattedEndDate,
            "gst": parseInt(newdata.selectedGST, 10),
            "shippingWeight": parseInt(newdata.selectedShippingWeight, 10),
            "shippingGST": parseInt(newdata.selectedShippingGST, 10),
            "conditions": newdata.conditions,
            "createdBy": userInfo.user_id
        };

        try {
            let response;
            if (id) {
                postData = { ...postData, id };
                response = await fetch('https://igapi.heuristticminds.com/api/InventoryList/Update-UpdateInventoryDetails', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(postData),
                });
            } else {
                response = await fetch('https://igapi.heuristticminds.com/api/InventoryList/Add-SaveInventoryDetails', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(postData),
                });
            }

            if (response.ok) {
                if (id) {
                    alert('Inventory Updated Successfully!');
                } else {
                    alert('Inventory Added Successfully!');
                }
                navigate('/inventoryAll');
            }

        } catch (error) {
            console.error('Error updating data:', error);
        }
    };

    

    const onChangehandle = async(e) => {
        const { name, value } = e.target;
    setNewdata(prevState => ({ ...prevState, [name]: value }));

    if (name === "selectedArtwork" && value !== "0") {
        try {
            const artworkId = parseInt(value, 10);
            const response = await axios.get(`https://igapi.heuristticminds.com/api/InventoryList/Get-GetArtworkDetailsForInventoryByID?id=${artworkId}&&mode=0`);
            const data = response.data;

            setNewdata(prevData => ({
                ...prevData,
                image: data.image,
                artworkTitle: data.productTitle || "",
                price:data.price || "",
                category: data.category || "",
                categoryType: data.categoryType || "",
                artistname: data.artistName || "",
                size: data.size || "",
                weight: data.weight || "", 
                commission: data.commission
            }));
        } catch (error) {
            console.error("Error fetching artwork details:", error);
        }
    } 

    };

    
    return (
        <>
            {loading ? <Loader /> : ''}
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">
                    <div>
                        <div className="page-header">
                            <div className="container-xl px-4">
                                <div className="page-header-title">
                                    <div className="page-header-icon">
                                        <i className="bi bi-images"></i>
                                    </div>
                                    {id > 0 ? "Edit Inventory" : "Add New Inventory"}                                    
                                </div>
                            </div>
                        </div>
                        <div className="container-xl px-4">
                            <div className="row">
                                <div className="col-lg-12 mb-4">
                                    <div className="card mb-4 h-100">
                                        <div className="card-header">Details of Inventory</div>
                                        <div className="card-body">
                                            <NavLink className="btn btn-primary float-end" to={'/inventoryAll'}  onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                            <div className="p-4">
                                            {(id || (newdata.selectedArtwork !== "0" && newdata.artworkTitle)) ? (
                                                <div className="row">
                                                    <div className="col-sm-5">
                                                        <div className="imgpreview">
                                                            <img src={`../images/products/thumbnail/${newdata.image}`} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className="col-sm-5">
                                                        <div className="imgpreview">
                                                            {/* <h2 className="fs-6">{row.productTitle}</h2> */}
                                                            <h2 className="fs-6">{newdata.artworkTitle}</h2>
                                                            <span className="d-block"><b>{newdata.category}:</b> {newdata.categoryType}</span>
                                                            <span className="d-block"><b>Art by:</b> {newdata.artistname}</span>
                                                            <span className="d-block"><b>Artwork Price:</b> {newdata.price}</span>
                                                            <span className="d-block"><b>Size:</b> {newdata.size}</span>
                                                            <span className="d-block"><b>Weight:</b> {newdata.weight} grms</span>
                                                            <span className="d-block"><b>Commission:</b> {newdata.commission}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                ): null}
                                                <div className="row">
                                                    <div className="col-sm-9 form-group mb-3">
                                                        <label>Artwork Name *</label>
                                                        {id ?
                                                            <p className="form-control-plaintext">{newdata.artworkTitle}</p>
                                                            :
                                                            <select className="form-select" value={newdata.selectedArtwork} name="selectedArtwork" onChange={onChangehandle}>
                                                                <option value="0">-- Select --</option>
                                                                {
                                                                    artworks.map((artworkList) => (
                                                                    <option key={artworkList.id} value={artworkList.id}>
                                                                    {artworkList.productTitle}</option>
                                                                ))}
                                                            </select>
                                                        }
                                                    </div>
                                                    {/* <div className="col-sm-3 form-group mb-3">
                                                        <label>Quantity *</label>
                                                        <input type="number" name="quantity" value={newdata.quantity} onChange={onChangehandle} className="form-control" min="1" />
                                                    </div> */}
                                                    
                                                    {/* <div className="col-sm-3 form-group mb-3">
                                                        <label>Entry Date *</label>
                                                        <DatePicker
                                                            selected={newdata.entryDate}
                                                            onChange={date => handleDateChange(date, 'entryDate')}
                                                            className="form-control"
                                                            dateFormat="yyyy-MM-dd"
                                                            customInput={<CustomInput />}
                                                        />
                                                    </div> */}
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>End Date *</label>
                                                        <DatePicker
                                                            selected={newdata.endDate}
                                                            onChange={date => handleDateChange(date, 'endDate')}
                                                            className="form-control"
                                                            dateFormat="yyyy-MM-dd"
                                                            customInput={<CustomInput />}
                                                        />
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Status *</label>
                                                        <select className="form-select" value={newdata.selectedStatus} name="selectedStatus" onChange={onChangehandle}>
                                                        <option value={0}>--Select--</option>
                                                            {statusType.map((statusList) => (
                                                                <option key={statusList.id} value={statusList.id}>
                                                                    {statusList.statusType}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>MRP *</label>
                                                        <input type="text" name="mrp" value={newdata.mrp} onChange={onChangehandle} className="form-control" />
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>Discount *</label>
                                                        <input type="text" name="discount" value={newdata.discount} onChange={onChangehandle} className="form-control" />
                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label>GST Slot *</label>
                                                        <select className="form-select" value={newdata.selectedGST} name="selectedGST" onChange={onChangehandle}>
                                                        <option value={0}>--Select--</option>
                                                                    {GSTType.map((GSTList) => (
                                                                <option key={GSTList.id} value={GSTList.id}>
                                                                    {GSTList.gstSlot}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-4 form-group mb-4">
                                                        <label>Shipping Weight *</label>
                                                        <select 
                                                            className="form-select" 
                                                            value={newdata.selectedShippingWeight} 
                                                            name="selectedShippingWeight" 
                                                            onChange={onChangehandle}
                                                            
                                                        >
                                                        <option value={0}>--Select--</option>
                                                                    {ShipWeight.map((ShipWeightList) => (
                                                                <option key={ShipWeightList.id} value={ShipWeightList.id}>
                                                                    {ShipWeightList.shipWeightSlot}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-4 form-group mb-4">
                                                        <label>Shipping GST Slot *</label>
                                                        <select 
                                                            className="form-select" 
                                                            value={newdata.selectedShippingGST} 
                                                            name="selectedShippingGST" onChange={onChangehandle}>
                                                        <option value={0}>--Select--</option>
                                                                    {ShipGSTType.map((shipGSTList) => (
                                                                <option key={shipGSTList.id} value={shipGSTList.id}>
                                                                    {shipGSTList.gstSlot}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-12 form-group mb-12">
                                                        {/* Display DataTable with currency conversion rates */}
                                            {shouldDisplayDataTable && (
                                                <div className="mt-4">
                                                    <h5>Converted Prices</h5>
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th>Currency</th>
                                                                <th>ROE</th>
                                                                <th>MRP</th>
                                                                <th>Discount</th>
                                                                <th>Disc Price</th>
                                                                <th>GST</th>
                                                                <th>Display Price</th>
                                                                <th>Shipping Cost</th>
                                                                <th>Shipping GST</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {currencyRates.map((currency) => (
                                                                <tr key={currency.currency}>
                                                                     {/* Display the country name and flag */}
                    
                                                                    <td><ReactCountryFlag countryCode={currency.code} svg style={{ width: '2em', height: '2em', marginRight: '0.5em' }} />{currency.currency}</td>
                                                                    <td>{currency.value}</td>
                                                                    <td>{currency.mrp.toFixed(2)}</td>
                                                                    <td>{currency.discount.toFixed(2)}</td>
                                                                    <td>{currency.salePrice.toFixed(2)}</td>
                                                                    <td>{currency.gst.toFixed(2)}</td>                                                                    
                                                                    <td>{currency.convertedValue.toFixed(2)}</td>
                                                                    <td>{currency.shippingCost.toFixed(2)}</td>
                                                                    <td>{currency.shippingGST.toFixed(2)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            )}

                                                    </div>
                                                    
                                                    <div className="col-12 form-group mb-4">
                                                        <label>Conditions</label>
                                                            <CustomEditor 
                                                                ref={editorRef} 
                                                                value={newdata.conditions} 
                                                                onChange={handleEditorChange} 
                                                            />                                                    
                                                    </div>
                                                </div>
                                                <button className="btn btn-primary" type="button" onClick={handleAddInventoryClick}>Save Inventory</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    );
};

export default AddInventory;
